import { plainToInstance } from "class-transformer";
import { validateOrReject } from "class-validator";

/**
 * Generic transformer to convert a plain object into a class instance.
 * @param classType The class to transform the object into.
 * @returns A function to be used inside `@Transform()`
 */
export default function transform<T extends object>(
  classType: new () => T
) {
  return async (value: any) => {
    const instance = plainToInstance(classType, value);
    await validateOrReject(instance);
    return instance;
  };
}
